import axios from 'axios';
import apiConfig from '../shared/config/api.config';

export default function startCheckinRequest(
  hotelId,
  bookingIdentifier,
  lang,
  enableCache = false,
  source
) {
  const {
    host,
    URIs: { startCheckin },
  } = apiConfig;

  const uri = `${host}${startCheckin}`.replace(':hotelId', hotelId);

  return axios
    .post(uri, { bookingIdentifier }, { params: { lang, enableCache, source } })
    .then(res => {
      return res.data;
    });
}
